import React, { useCallback } from "react";
import { Button } from "react-bootstrap";

function MobileAppAuthPinNumbersButton(props) {
    const {disabled, number, onClick} = props;

    const handleClick = useCallback((e) => {
        const num = e.target.dataset.num;
        onClick(num);
    }, [onClick]);

    return <Button disabled={disabled} variant="outline-info" data-num={number} onClick={handleClick}>
        {number}
    </Button>
}

export default MobileAppAuthPinNumbersButton;
